import {Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {Tip} from 'shared/models/tips/tip';
import {Tiplist} from 'shared/models/tips/tiplist';
import {TipListOverviewRepository} from '../repositories/tip-list-overview.repository';

@Injectable()
export class TipListOverviewService {

  constructor(private tiplistOverviewRepository: TipListOverviewRepository) { }

  public getTiplists(): Observable<Array<Tiplist>> {
    return this.tiplistOverviewRepository.getTiplists()
      .map((tiplists: Array<Tiplist>) => {
        return tiplists.map((tiplist: Tiplist) => {
          tiplist.languageCount = {
            de: this.getLanguageCount(tiplist, 'de'),
            en: this.getLanguageCount(tiplist, 'en'),
          };

          return tiplist;
        });
      });
  }

  public deleteTiplist(id: string): Observable<Response> {
    return this.tiplistOverviewRepository.deleteTiplist(id);
  }

  private getLanguageCount(tiplist: Tiplist, language: string): Number {
    return tiplist.tips.filter((tip: Tip) => {
      return tip.text[language] !== null &&
             tip.text[language] !== undefined &&
             tip.text[language].length > 0;
    }).length;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/tip-list/tip-list-overview/services/tip-list-overview.service.ts